<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col>
          <b-card-title>{{ $t('teams.members.title') }}</b-card-title>
        </b-col>
        <b-col>
          <div class="text-right">
            <b-button
              variant="primary"
              @click="addRow"
            >
              <FeatherIcon icon="PlusIcon" /> {{ $t('common.add') }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card-body>
    <template v-if="dataLoading">
      <loading />
    </template>
    <template v-else>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="dataList"
        striped
      >
        <template #cell(name)="data">
          <member-users-select-card :i-key="data.index" />
        </template>
        <template #cell(control)="data">
          <div class="text-right">
            <b-button
              variant="success"
              size="sm"
              class="mr-1"
              @click="saveRow(data.item)"
            >
              <feather-icon icon="SaveIcon" />
            </b-button>
            <b-button
              variant="danger"
              size="sm"
              @click="removeData(data.item,data.index)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
      <b-card-footer>
        <b-pagination
          v-if="dataCounts > perPage"
          v-model="currentPage"
          :total-rows="dataCounts"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </b-card-footer>
    </template>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody, BTable, BPagination, BButton, BCardFooter, BCardTitle, BRow, BCol,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Loading from '@/layouts/components/common/Loading.vue'
import MemberUsersSelectCard from '@/views/Teams/Components/MemberUsers.vue'

const tableName = 'team_members'
export default {
  name: 'TeamMembers',
  components: {
    MemberUsersSelectCard,
    Loading,
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    BCardTitle,
    BRow,
    BCol,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.id_member_users AS id_member_users`,
          'users.name AS name',
        ],
        where: {},
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'name',
          label: this.$t('teams.members.user'),
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ]
    },
    dataList() {
      return this.$store.getters['teamMembers/dataList']
    },
    team() {
      return this.$store.getters['teams/dataItem']
    },
    dataCounts() {
      return this.$store.getters['teamMembers/dataCounts']
    },
    saveData() {
      return this.$store.getters['teamMembers/dataSaveStatus']
    },
    dataLoading() {
      return this.$store.getters['teamMembers/loading']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: this.$t('common.toast.success'), icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: this.$t('common.toast.error'), icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    this.getDataList()
    this.getUsersList()
  },
  methods: {
    getUsersList() {
      this.$store.dispatch('users/getDataList', {
        select: [
          'users.id AS id',
          'users.name AS name',
          'user_types.title AS user_types',
        ],
        where: {
          'users.status': 1,
        },
      })
    },
    addRow() {
      this.dataList.push({
        id_member_users: null,
        id_teams: this.team.id,
      })
    },
    saveRow(row) {
      if (row.id_member_users) {
        this.$store.dispatch('teamMembers/saveData', row)
          .then(res => {
            if (res.status) {
              this.$swal({
                icon: 'success',
                title: this.$t('teams.members.successTitle'),
                text: this.$t('teams.members.added'),
                confirmButtonText: this.$t('alerts.remove.resultClose'),
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            } else {
              this.$swal({
                icon: 'error',
                title: this.$t('teams.members.failTitle'),
                text: res.message,
                confirmButtonText: this.$t('alerts.remove.resultClose'),
              })
            }
          })
      } else {
        this.$swal({
          icon: 'error',
          title: this.$t('teams.members.failTitle'),
          text: this.$t('teams.members.selectRequired'),
          confirmButtonText: this.$t('alerts.remove.resultClose'),
        })
      }
    },
    getDataList() {
      this.dataQuery.where['team_members.id_teams'] = this.team.id
      this.$store.dispatch('teamMembers/getDataList', this.dataQuery)
    },
    removeData(row, index) {
      if (row.id) {
        this.$swal({
          title: this.$t('alerts.remove.title'),
          text: this.$t('alerts.remove.message'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('alerts.remove.confirm'),
          cancelButtonText: this.$t('alerts.remove.cancel'),
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            this.$store.dispatch('teamMembers/removeData', row.id)
              .then(res => {
                if (res) {
                  this.$swal({
                    icon: 'success',
                    title: this.$t('alerts.remove.resultTitle'),
                    text: this.$t('alerts.remove.resultMessage'),
                    confirmButtonText: this.$t('alerts.remove.resultClose'),
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  })
                  this.dataList.splice(index, 1)
                } else {
                  this.$swal({
                    icon: 'error',
                    title: this.$t('alerts.remove.resultTitle'),
                    text: this.$t('alerts.remove.resultMessage'),
                    confirmButtonText: this.$t('alerts.remove.resultClose'),
                  })
                }
              })
          }
        })
      } else {
        this.dataList.splice(index, 1)
      }
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
